import React from "react";
import PropTypes from "prop-types";
import RadioButton from "./RadioButton";
import "./GenderFilter.css";

const GenderFilter = ({ gender, onChange, options }) => {
  return (
    <div className="gender-filter">
      {options.map((opt) => {
        // 타입과 값을 정확히 비교하기 위해 문자열로 변환
        const normalizedGender =
          gender === null || gender === undefined ? "" : String(gender);
        const normalizedOptValue = String(opt.value);
        const isChecked = normalizedGender === normalizedOptValue;

        return (
          <RadioButton
            key={opt.label}
            label={opt.label}
            name="gender"
            value={opt.value}
            checked={isChecked}
            onChange={() => onChange(opt.value)}
          />
        );
      })}
    </div>
  );
};

GenderFilter.propTypes = {
  gender: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
};

export default GenderFilter;
